import { render, staticRenderFns } from "./CreateInformation.vue?vue&type=template&id=28f31e25&scoped=true&"
import script from "./CreateInformation.vue?vue&type=script&lang=js&"
export * from "./CreateInformation.vue?vue&type=script&lang=js&"
import style1 from "./CreateInformation.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./CreateInformation.vue?vue&type=style&index=2&id=28f31e25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f31e25",
  null
  
)

export default component.exports